import { useEffect, useCallback } from 'react'

export default function Lightbox({ photos, index, onClose, onNavigate }) {
  const photo = photos[index]

  const go = useCallback(
    (delta) => {
      const next = (index + delta + photos.length) % photos.length
      onNavigate(next)
    },
    [index, photos.length, onNavigate]
  )

  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') go(1)
      if (e.key === 'ArrowLeft') go(-1)
    }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [go, onClose])

  if (!photo) return null

  return (
    <div className="lb" onClick={onClose}>
      <button className="lb-x" onClick={onClose} aria-label="Fechar">×</button>
      {photos.length > 1 && (
        <button
          className="lb-arrow l"
          onClick={(e) => { e.stopPropagation(); go(-1) }}
          aria-label="Anterior"
        >‹</button>
      )}
      <img className="lb-img" src={photo.full} alt={photo.caption || ''} onClick={(e) => e.stopPropagation()} />
      {photos.length > 1 && (
        <button
          className="lb-arrow r"
          onClick={(e) => { e.stopPropagation(); go(1) }}
          aria-label="Seguinte"
        >›</button>
      )}
      <div className="lb-cap">
        {photo.caption}
        <span className="lb-count">{index + 1} / {photos.length}</span>
      </div>
    </div>
  )
}
